const DEFAULT_OBJECT = {};
const NOT_AVAILABLE = 'Not Available';

function isStreetAvailable(street) {
  return street && street !== NOT_AVAILABLE;
}

/**
 * Convert address object to formatted address.
 * E.g. { zip: '97005', stateCode: 'OR', street: '12325 SW Canyon Rd', city: 'Beaverton' }
 * => 12325 SW Canyon Rd, Beaverton, OR, 97005
 * @param address
 * @returns {string}
 */
export function toDisplayFormattedAddress(address = DEFAULT_OBJECT) {
  const { zip, stateCode, street, city } = address;
  let formattedAddress = '';

  if (city && stateCode && zip) {
    formattedAddress = `${city}, ${stateCode} ${zip}`;
  }

  if (isStreetAvailable(street)) {
    formattedAddress = `${street}, ${formattedAddress}`;
  }

  return formattedAddress;
}

/**
 * Convert address object to query formatted address.
 * E.g. { stateCode: 'OR', zip: '97005', street: '12325 SW Canyon Rd', city: 'Beaverton' }
 * => Damerow Ford, 12325 SW Canyon Rd, Beaverton, OR 97005
 * @param {Object} address
 * @param {string} dealerName
 * @returns {string} formatted address
 */
export function toQueryFormattedAddress(address = DEFAULT_OBJECT, dealerName = '') {
  const { stateCode, stateName, zip, city, street } = address;
  const state = stateCode || stateName;

  const parts = [
    dealerName,
    isStreetAvailable(street) && street,
    city,
    state && zip ? `${state} ${zip}` : state || zip,
  ].filter(Boolean);

  return parts.join(', ');
}

/**
 * Convert address object to formatted address.
 * E.g. { zip: '97005', stateCode: 'OR', street: '12325 SW Canyon Rd', city: 'Beaverton' }
 * => Beaverton, OR
 * @param address
 * @returns {string} encoded address
 */
export function toShortFormattedAddress(address = DEFAULT_OBJECT) {
  const { stateCode, city } = address;
  let formattedAddress = '';
  if (city && stateCode) {
    formattedAddress = `${city}, ${stateCode}`;
  }
  return formattedAddress;
}
